const BodyModelPreview = require("./containers/BodyModelPreview");
const Authenticate = require("../utils").authenticate;

// Sync route definition
module.exports = {
    path: "/body-model/:id",
    component: Authenticate(BodyModelPreview),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/body-model-preview/index.js